<div class="flag-column">
  <h4 style="padding-bottom: 20px; border-bottom: 2px solid #e2e9f0">
    Add flags to image
    <span class="close" (click)="emitClose()"><i class="fa fa-close"></i></span>
  </h4>

  <h4 *ngIf="violations().length">
    <span
      >Violations <span class="count">({{ violations().length }})</span></span
    >
  </h4>

  <div class="col-lg-12" style="padding: 0 10px">
    <ng-container *ngFor="let flag of violations(); index as i">
      <div class="flag" [ngClass]="getFlagHighlightClass(flag)">
        <div class="col-md-0" style="padding: 0">
          <div class="icon-left">
            <i *ngIf="!scoresEnabled || !flag.score" class="fa fa-flag"></i>
            <i *ngIf="scoresEnabled && flag.score" class="fa fa-warning"></i>
          </div>
          <p class="score" *ngIf="scoresEnabled && flag.score">{{ flag.score }}</p>
        </div>

        <div class="col-md-9">
          <div [style.margin]="flag.text ? '' : '-15px 0 0 0'">
            <p class="main-text">
              <span *ngIf="buildingIndex(flag)">#{{ buildingIndex(flag) }} | </span>
              {{ flag.text }}
            </p>
          </div>

          <div>
            <p class="info-cl">
              <span style="font-size: 13px">{{ flag.user?.name }}</span
              ><br />
              <span class="date-cl">{{ dateTimeAsString(flag.updatedAt) }}</span
              >&nbsp; <span class="flag-type">{{ flag.subtype?.type?.name }}</span
              >&nbsp;
            </p>
          </div>
        </div>

        <div class="icon-right col-md-3">
          <div class="icon-div">
            <a (click)="flagReleased(flag, $event)" class="icon-cl">
              Click to pin &nbsp;
              <svg class="pin-icon" width="12" height="12">
                <path
                  d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z"></path>
                <path
                  d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <h4 *ngIf="discrepancies().length">
    <span
      >Discrepancies <span class="count">({{ discrepancies().length }})</span></span
    >
  </h4>

  <div class="col-lg-12" style="padding: 0 10px">
    <ng-container *ngFor="let flag of discrepancies(); index as i">
      <div class="flag" [ngClass]="getFlagHighlightClass(flag)">
        <div class="col-md-0" style="padding: 0">
          <div class="icon-left">
            <i *ngIf="!scoresEnabled || !flag.score" class="fa fa-flag"></i>
            <i *ngIf="scoresEnabled && flag.score" class="fa fa-warning"></i>
          </div>
          <p class="score" *ngIf="scoresEnabled && flag.score">{{ flag.score }}</p>
        </div>

        <div class="col-md-9">
          <div [style.margin]="flag.text ? '' : '-15px 0 0 0'">
            <p class="main-text">
              <span *ngIf="buildingIndex(flag)">#{{ buildingIndex(flag) }} | </span>
              {{ flag.text }}
            </p>
          </div>

          <div>
            <p class="info-cl">
              <span style="font-size: 13px">{{ flag.user?.name }}</span
              ><br />
              <span class="date-cl">{{ dateTimeAsString(flag.updatedAt) }}</span
              >&nbsp; <span class="flag-type">{{ flag.subtype?.type?.name }}</span
              >&nbsp;
            </p>
          </div>
        </div>

        <div class="icon-right col-md-3">
          <div class="icon-div">
            <a (click)="flagReleased(flag, $event)" class="icon-cl">
              Click to pin &nbsp;
              <svg class="pin-icon" width="12" height="12">
                <path
                  d="M7.42282 10.5439L1.45659 4.5777C1.35609 4.4772 1.32574 4.32596 1.38037 4.19461C1.43475 4.06303 1.56293 3.97758 1.70519 3.97758C4.027 3.97758 6.11236 2.688 7.14801 0.612354L7.35703 0.194557C7.40728 0.0933302 7.50365 0.0226896 7.6151 0.00447869C7.72678 -0.0134744 7.84014 0.0231818 7.92002 0.103033L11.8975 4.08052C11.9774 4.16039 12.014 4.27376 11.9961 4.38544C11.9778 4.49686 11.9072 4.59324 11.806 4.64351L11.3884 4.85229C9.31249 5.88816 8.02293 7.97351 8.02293 10.2953C8.02293 10.4376 7.93748 10.5658 7.8059 10.6201C7.67456 10.6748 7.52332 10.6444 7.42282 10.5439Z"></path>
                <path
                  d="M3.1962 7.3125L0.600143 9.90857C0.561542 9.94717 0.532409 9.99426 0.515182 10.046L0.0180025 11.5375C-0.0239975 11.664 0.00876813 11.8031 0.102963 11.8973C0.197159 11.9915 0.33626 12.0243 0.462753 11.9823L1.95432 11.4851C2.00602 11.4679 2.05313 11.4388 2.09173 11.4002L4.68781 8.80408L3.1962 7.3125Z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
